import React, {useCallback, useRef} from 'react';
import {useCmrDocument} from '../../../hooks/useCmrDocument';
import {formatDate} from '../../../utils';
import {Commande} from '../../../model/Commande';

interface CmrCellProps {
    order: Commande;
}

export function CmrCell({order}: CmrCellProps) {
    const {document, isUploading, upload, download} = useCmrDocument(order);
    const inputRef = useRef<HTMLInputElement>(null);

    const onPick = useCallback(() => {
        inputRef.current?.click();
    }, []);

    const onChange = useCallback(async (e: React.ChangeEvent<HTMLInputElement>) => {
        const file = e.target.files?.[0];
        if (file) {
            await upload(file);
        }
        e.target.value = '';
    }, [upload]);

    return (
        <div className="d-flex align-items-center" style={{fontSize: '12px'}}>
            {
                isUploading
                    ? <span className="text-muted">Téléversement…</span>
                    : document
                        ? (
                            <button
                                type="button"
                                onClick={download}
                                className="btn btn-link p-0 text-decoration-none text-primary"
                                aria-label={`${document.uploadedBy ?? 'Transporteur'}, le ${formatDate(document.createdAt, 'fr-FR', {}, 'date')}`}
                                title={`${document.uploadedBy ?? 'Transporteur'}, le ${formatDate(document.createdAt, 'fr-FR', {}, 'date')}`}
                            >
                                <i className="fas fa-file-alt me-1"/>
                                <span className="fw-bold fs-6">{document.filename}</span>
                            </button>
                        )
                        : (
                            <>
                                <button
                                    type="button"
                                    onClick={onPick}
                                    className="btn btn-link p-0"
                                    title="Ajouter un CMR"
                                    aria-label="Ajouter un CMR"
                                >
                                    <i className="fas fa-paperclip me-1"/>
                                    <span className="text-muted fs-6">Ajouter un CMR</span>
                                </button>
                                <input
                                    ref={inputRef}
                                    type="file"
                                    hidden
                                    onChange={onChange}
                                    accept="application/pdf,image/*"
                                />
                            </>
                        )
            }
        </div>
    );
}
